import styled from 'styled-components';

export const Table = styled.table`
  margin: 24px 0;
  border-collapse: collapse;
`;

export const TableHead = styled.thead`
  font-weight: bold;
  font-size: 16px;
  line-height: 26px;
  color: #13171b;
`;

export const TableBody = styled.tbody`
  p {
    padding-top: 32px;
  }
`;

export const Th = styled.th`
  padding: 0 24px 24px 24px;
  border-right: 1px solid #d9d9d9;
  text-align: left;
  font-size: 16px;
  line-height: 26px;
  font-weight: bold;
  color: #13171b;
  min-width: 118px;

  &:last-child {
    border-right: none;
  }

  &:first-child {
    padding: 0 24px 24px 0;
  }
`;

export const Td = styled.td`
  padding: 0 24px 24px 24px;
  border-right: 1px solid #d9d9d9;
  white-space: nowrap;
  font-size: 16px;
  line-height: 26px;
  color: #13171b;
  min-width: 118px;

  &:last-child {
    border-right: none;
  }

  &:first-child {
    padding: 0 24px 24px 0;
  }
`;
